import { FormControl, Grid, TextField } from '@material-ui/core';
import React from 'react';

const generalChecklistItemsV2 = [
  {
    key: 'createSystem',
    label:
      '1. Create a safe, organized system for all important documents, username/password information, and any other notes/information that will become an important part of your plan.',
    confirmKey: 'confirmCreateSystem',
    points: 4,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'createEmail',
    label:
      '2. Verify your email address is appropriate and that it is stored, along with your password, in your accordion file accordion folder. Create and access the email account with a trusted adult.',
    confirmKey: 'confirmCreateEmail',
    points: 4,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
    extra: (form, emailAddress, isFieldDisabled, classes) => (
      <Grid container direction="row" style={{ margin: '10px 0 5px 50px' }}>
        <Grid item xs={9}>
          <label>Email Address: {emailAddress}</label>
        </Grid>
      </Grid>
    ),
  },
  {
    key: 'loginToWeb',
    label: '3. Successfully log into the Successful Futures website.',
    confirmKey: 'confirmLoginToWeb',
    points: 4,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'obtainCopies',
    label:
      '4. Obtain original copies of official documents, such as birth certificate, social security card,  immunization records, school transcripts, etc.',
    confirmKey: 'confirmObtainCopies',
    points: 4,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'obtainPermit',
    label: "5. Obtain your driver's (learner) permit.",
    confirmKey: 'confirmObtainPermit',
    points: 4,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'registerDriversEd',
    label: "6. Register for a Driver's Education course.",
    confirmKey: 'confirmRegisterDriversEd',
    points: 4,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'completePlanningMeeting1',
    label: '7. Complete Planning Meeting #1 (form, module submissions, meeting)',
    confirmKey: 'confirmCompletePlanningMeeting1',
    points: 2,
    due: 'During Phase 1',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'completePlanningMeeting2',
    label: '8. Complete Planning Meeting #2 (form, module submissions, meeting)',
    confirmKey: 'confirmCompletePlanningMeeting2',
    points: 2,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'boysTownScholarship',
    label: '9. Complete the Boys Town scholarship application.',
    confirmKey: 'confirmBoysTownScholarship',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'requestLettersofRecommendation',
    label: '10. Complete the request for letters of recommendation for your scholarship application. (3)',
    confirmKey: 'confirmRequestLettersofRecommendation',
    points: 4,
    due: 'Six weeks before Scholarship Application due',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'volunteerOpportunities',
    label: '11. Look for opportunities where you can volunteer or join community groups after graduation.',
    confirmKey: 'confirmVolunteerOpportunities',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'cleanUpSocialMedia',
    label: '12. Clean up your social media accounts.',
    confirmKey: 'confirmCleanUpSocialMedia',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'completeDriversEd',
    label: "13. Complete Driver's Education course.",
    confirmKey: 'confirmCompleteDriversEd',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'obtainDriversLicense',
    label: "14. Obtain a Driver's License or State ID.",
    confirmKey: 'confirmObtainDriversLicense',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
  {
    key: 'liveAfterGraduation',
    label: '15. Explore and identify where you will live after graduation.',
    confirmKey: 'confirmLiveAfterGraduation',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
    extra: (form, email, isFieldDisabled, classes, setForm) => (
      <Grid item xs={7} sm={5} md={5} lg={5} style={{ margin: '15px 0 0 10px' }}>
        <FormControl>
          <TextField
            id="live-after-graduation-v2"
            size="small"
            fullWidth
            label="I will live:"
            variant="outlined"
            value={form.liveAfterGraduationResponse}
            onChange={(event) => setForm({ ...form, liveAfterGraduationResponse: event.target.value })}
            InputProps={{ maxLength: 100, classes: { input: classes.textField } }}
            className={classes.root}
            disabled={isFieldDisabled(form.liveAfterGraduationResponse)}
          />
        </FormControl>
      </Grid>
    ),
  },
  {
    key: 'discussTransportationNeeds',
    label: '16. Discuss your transportation needs.  Identify options for transportation, if needed.',
    confirmKey: 'confirmDiscussTransportationNeeds',
    points: 4,
    due: 'During Phase 2',
    minVersion: 2,
    maxVersion: 99,
  },
];

export const generalChecklistItems = [
  {
    key: 'createSystem',
    label:
      '1. Create a safe, organized system for all important documents, username/password information, and any other notes/information that will become an important part of your senior plan.',
    confirmKey: 'confirmCreateSystem',
    points: 4,
    due: '1st Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'createEmail',
    label:
      '2. Verify your email address is appropriate and that it is stored, along with your password, in your senior binder. Create and access the email account with a trusted adult.',
    confirmKey: 'confirmCreateEmail',
    points: 4,
    due: '1st Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
    extra: (form, emailAddress, isFieldDisabled, classes) => (
      <Grid container direction="row" style={{ margin: '10px 0 5px 50px' }}>
        <Grid item xs={9}>
          <label>Email Address: {emailAddress}</label>
        </Grid>
      </Grid>
    ),
  },
  {
    key: 'loginToWeb',
    label: '3. Successfully log into the Successful Futures website.',
    confirmKey: 'confirmLoginToWeb',
    points: 4,
    due: '1st Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'obtainCopies',
    label:
      '4. Obtain original copies of official documents, such as birth certificate, social security card, immunization records, school transcripts, etc.',
    confirmKey: 'confirmObtainCopies',
    points: 5,
    due: '1st Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'obtainPermit',
    label: "5. Obtain your driver's (learner) permit.",
    confirmKey: 'confirmObtainPermit',
    points: 4,
    due: '1st Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'registerDriversEd',
    label: "6. Register for a Driver's Education course.",
    confirmKey: 'confirmRegisterDriversEd',
    points: 4,
    due: '1st Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'volunteerOpportunities',
    label: '7. Look for opportunities where you can volunteer or join community groups after graduation.',
    confirmKey: 'confirmVolunteerOpportunities',
    points: 5,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'cleanUpSocialMedia',
    label: '8. Clean up your social media accounts.',
    confirmKey: 'confirmCleanUpSocialMedia',
    points: 4,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'completeDriversEd',
    label: "9. Complete Driver's Education course.",
    confirmKey: 'confirmCompleteDriversEd',
    points: 5,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'obtainDriversLicense',
    label: "10. Obtain a Driver's License or State ID.",
    confirmKey: 'confirmObtainDriversLicense',
    points: 5,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'liveAfterGraduation',
    label: '11. Explore and identify where you will live after graduation.',
    confirmKey: 'confirmLiveAfterGraduation',
    points: 4,
    due: 'April - May',
    minVersion: 1,
    maxVersion: 1,
    extra: (form, email, isFieldDisabled, classes, setForm) => (
      <Grid item xs={7} sm={5} md={5} lg={5} style={{ margin: '15px 0 0 10px' }}>
        <FormControl fullWidth>
          <TextField
            id="live-after-graduation"
            size="small"
            fullWidth
            label="I will live:"
            variant="outlined"
            value={form.liveAfterGraduationResponse}
            onChange={(event) => setForm({ ...form, liveAfterGraduationResponse: event.target.value })}
            InputProps={{ maxLength: 100, classes: { input: classes.textField } }}
            className={classes.root}
            disabled={isFieldDisabled(form.liveAfterGraduationResponse)}
          />
        </FormControl>
      </Grid>
    ),
  },
  {
    key: 'discussTransportationNeeds',
    label: '12. Discuss your transportation needs. Identify options for transportation, if needed.',
    confirmKey: 'confirmDiscussTransportationNeeds',
    points: 4,
    due: 'March',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'boysTownScholarship',
    label: '13. Complete the Boys Town scholarship application.',
    confirmKey: 'confirmBoysTownScholarship',
    points: 4,
    due: 'March',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'requestLettersofRecommendation',
    label: '14. Complete the request for letters of recommendation for your scholarship application. (3)',
    confirmKey: 'confirmRequestLettersofRecommendation',
    points: 4,
    due: 'March',
    minVersion: 1,
    maxVersion: 1,
  },
  ...generalChecklistItemsV2,
];
